import React from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress, Typography } from '@material-ui/core'
import clsx from 'clsx'

import { EventCard } from '../EventCard'
import { SectionBlock } from '../SectionBlock'

import { useStyles } from './UpcomingEventsSection.style'

const UpcomingEventsSection = () => {
  const classes = useStyles()

  const { upcomingEvents, upcomingEventsPending } = useSelector((state) => state.organizations)

  return (
    <SectionBlock>
      <div className={classes.upcomingContainer}>
        <div
          className={clsx(classes.upcomingMainContainer, !!upcomingEvents.length && 'hasEvents')}>
          <div className={classes.upcomingHeader}>
            <Typography color='primary' variant='h6' className={classes.upcomingTitle}>
              Próximos eventos del organizador
            </Typography>
          </div>

          <div className={classes.upcomingEventsContainer}>
            {upcomingEventsPending ? (
              <CircularProgress color='primary' size={32} />
            ) : upcomingEvents.length > 0 ? (
              upcomingEvents.map((event) => <EventCard key={event.id} event={event} />)
            ) : (
              <Typography variant='body1' color='primary'>
                No hay próximos eventos para el organizador
              </Typography>
            )}
          </div>
        </div>
      </div>
    </SectionBlock>
  )
}

export default UpcomingEventsSection
